export default __webpack_public_path__ + "static/media/userjourney3.180f38a2.png";